"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntroText = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Returns styled intro text. On desktop is centered.
 * Renders if `text` has thruthy value.
 */
const IntroText = ({
  text,
  className,
  isOverflowVisible = false
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const html = (0, _react.useMemo)(() => text ? (0, _utils.wrapInParagraph)((0, _sanitizeHtml.default)(text)) : null, [text]);
  if (!html) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTextWithHtml, {
    className: className,
    html: (0, _utils.wrapInParagraph)(html),
    isOverflowVisible: isOverflowVisible,
    testId: getTestId(_constants.INTRO_TEXT)
  });
};
exports.IntroText = IntroText;
